export default "__VITE_ASSET__95766738__"